const isMergeableObject = (value)=>{
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};
/**
 * Deep merge two objects, if the incoming values are undefined
 * then the base value will be used. This way undefined does not
 * override the base value as it would happen using the deepmerge library.
 * This is the reason we write our own deep merge function instead
 * of using deepmerge.
 **/ export const themeDeepMerge = (target, source)=>{
    if (source === undefined) {
        return target;
    }
    if (isMergeableObject(target) && isMergeableObject(source)) {
        const destination = {
            ...target
        };
        for (const key of Object.keys(source)){
            const sourceKey = key;
            if (source[sourceKey] !== undefined) {
                if (isMergeableObject(source[sourceKey])) {
                    destination[sourceKey] = target[sourceKey] === undefined ? source[sourceKey] : themeDeepMerge(target[sourceKey], source[sourceKey]);
                } else {
                    destination[sourceKey] = source[sourceKey];
                }
            } else {
                destination[sourceKey] = target[sourceKey];
            }
        }
        return destination;
    }
    return source;
};

//# sourceMappingURL=themeDeepMerge.js.map